import React from 'react';
// import axios from 'axios';
import {
  Collapse,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Nav,
  Container,
} from 'reactstrap';
import moment from 'moment';

import { ApiContext } from 'src/utils/ApiContext';
import { notification } from 'antd';
// v10
// import { useTranslation } from 'react-i18next';
// v9: the hoc
import { withNamespaces } from 'react-i18next';
import LanguageBar from './LanguageBar';

export default withNamespaces()(StatusBar);
function StatusBar(props) {

  const { time } = props;
  const { t } = props;
  const { onCheckBalance } = props;

  const apiCtx = React.useContext(ApiContext);

  const [isOpen, setIsOpen] = React.useState(false);

  const uidRef = React.useRef(null);
  // const emailRef = React.useRef(null);
  const passwordRef = React.useRef(null);

  const onRegisterClick = () => {
    apiCtx.setShowRegister(true);
  };

  const onLoginClick = () => {
    if (uidRef.current.value === ''
      || passwordRef.current.value === '') {
      notification.error({
        message: t('common.error'),
        description: t('statusbar.accountOrPasswordCanNotBeEmpty'),
      });

      return
    }

    apiCtx.login(
      uidRef.current.value,
      passwordRef.current.value,
    )
  };

  return (
    <div style={{ backgroundColor: '#162831' }}>
      <Container>
        <Navbar expand={'md'} dark>
          <NavbarBrand>
            <div style={{ color: 'white', fontSize: 10 }}>
              <p>Clock: {moment(time).format('YYYY-MM-DD hh:mm:ss')}<br />
                E Pay Account ID: {apiCtx.accountId}<br />
                {/* Account Name: {apiCtx.accountName}<br/> */}
                E Pay Store ID: {apiCtx.storeId}<br />
                E Pay Store Name: {apiCtx.storeName}<br />
                E Pay Store Public Key: {apiCtx.publicKey}<br />
                E Pay Public Key: {apiCtx.matchPay_publicKey}<br />
                Demo Version: {apiCtx.version}</p>
            </div>
            <LanguageBar />
          </NavbarBrand>

          <NavbarToggler onClick={() => setIsOpen(!isOpen)} />

          <Collapse isOpen={isOpen} navbar>
            <Nav className={'ml-auto'} navbar>
              <div className="form-inline">
                <input
                  ref={uidRef}
                  type={'text'}
                  name={'uid'}
                  pattern={'^(?=.*[a-z])(?=.*\\d)[a-z\\d]{6,15}$'}
                  placeholder={t('statusbar.pleaseInputYourAccount')}
                  className={'form-control mr-2 my-2 my-lg-0'}
                  onKeyUp={(e) => {
                    if (e.key === 'Enter') {
                      passwordRef.current.focus()
                    }
                  }}
                />

                {/* <input
                  ref={emailRef}
                  type={'email'}
                  name={'email'}
                  placeholder={'您的信箱'}
                  className={'form-control mr-2 my-2 my-lg-0'}
                /> */}

                <input
                  ref={passwordRef}
                  type={'password'}
                  name={'password'}
                  placeholder={t('statusbar.pleaseEnterYourPassword')}
                  className={'form-control mr-2 my-2 my-lg-0'}
                  onKeyUp={(e) => {
                    if (e.key === 'Enter') {
                      onLoginClick();
                    }
                  }}
                />
              </div>

              <button
                className={'btn btn-success mr-4 my-2 my-lg-0'}
                onClick={onLoginClick}
              >
                {t('statusbar.login')}
              </button>

              <button
                className={'btn btn-danger mr-2 my-2 my-lg-0'}
                onClick={onRegisterClick}
              >
                {t('statusbar.regist')}
              </button>

              <button
                className={'btn btn-info mr-2 my-2 my-lg-0'}
                onClick={onCheckBalance}
              >
                {t('statusbar.balance')}
              </button>
            </Nav>
          </Collapse>
        </Navbar>
      </Container>
    </div>
  );
};
